type FileForContent = {
  uri: string;
  name: string;
  mimeType: string;
  file?: any;
};

export async function getFileContent(file: FileForContent) {
  return file.file!;
}
